import React, { Component, useEffect, useState } from "react";

//custom
import { Checkbox } from "react-materialize";
//axios import
import axios from "axios";

//assests
import logo from "../../assests/images/logo.png";

//utils
import {
  set_login_detail,
  getuniquedeviceid,
  isloginuser,
} from "../../utils/Helper/CheckAuth";
import {
  showLoading,
  stopLoading,
  onlynumber,
  ismobileno,
  isvalidotp,
  fun_input_focus,
  gotohome,
  gotoeditprofile,
  sent_clean_var,
} from "../../utils/Helper/JSHelper";
import CallURL from "../../utils/API/CallURL";

//components
import ContactUs from "../../components/ContactUs/ContactUs";

function Login() {
  //temp avriable first load
  const [list_temp_load, set_list_temp_load] = useState([]);

  //verify mobile variable
  const [enter_name, set_enter_name] = useState("");
  const [enter_mobile, set_enter_mobile] = useState("");
  const [enter_otp, set_enter_otp] = useState("");
  const [is_sent, set_is_sent] = useState(false);
  const [timer_count, set_timer_count] = useState(0);

  //login variable
  const [is_check, set_is_check] = useState(false);

  //checkbox_text
  const checkbox_text = "Click on checkbox to agree our terms and conditions.";

  //starting on mount
  useEffect(() => {
    //change background color
    document.body.style = "background: white;";
    if (isloginuser()) {
      gotohome();
    }
  }, [list_temp_load]);

  //set timer_count
  useEffect(() => {
    const timer =
      timer_count > 0 &&
      setInterval(() => set_timer_count(timer_count - 1), 1000);
    return () => clearInterval(timer);
  }, [timer_count]);

  //validate data
  function handle_enter_mobile(e) {
    if (onlynumber(e, 10)) {
      set_enter_mobile((enter_mobile) => e.target.value);
    }
  }
  function handle_enter_otp(e) {
    if (onlynumber(e, 6)) {
      set_enter_otp((enter_otp) => e.target.value);
    }
  }
  //form function
  function fun_edit_mobile_no() {
    set_is_sent(false);
    set_enter_otp("");
  }
  function fun_send_otp() {
    if (enter_name.trim() == "") {
      alert("Enter Full Name");
      fun_input_focus("enter_name");
    } else if (!ismobileno(enter_mobile)) {
      alert("Enter Valid Mobile No");
      fun_input_focus("enter_mobile");
    } else if (is_check == false) {
      alert(checkbox_text);
    } else {
      showLoading();
      // Create an object of formData
      const formData = new Object();
      // Update the formData object
      formData.enter_mobile = enter_mobile;
      // Send formData object
      axios
        .post(CallURL.login, formData)
        .then((response) => {
          stopLoading();
          //console.log(response);
          //alert(response.data.apires);
          if (response.data.apires == "success") {
            //is sent true
            set_is_sent(true);
            set_timer();
          } else {
            alert("Something went wrong. Try again.");
          }
        })
        .catch((error) => {
          stopLoading();
          console.log(error);
          alert("Something went wrong. Try again.");
        });
    }
  }
  function set_timer() {
    set_timer_count(120);
  }
  function fun_re_send_otp() {
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.enter_mobile = enter_mobile;
    // Send formData object
    axios
      .post(CallURL.resend_otp, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "success") {
          //is sent true
          set_is_sent(true);
          set_timer();
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }
  function fun_verify_otp() {
    if (enter_name.trim() == "") {
      alert("Enter Full Name");
      fun_input_focus("enter_name");
    } else if (!ismobileno(enter_mobile)) {
      alert("Enter Valid Mobile No");
      fun_input_focus("enter_mobile");
    } else if (!isvalidotp(enter_otp)) {
      alert("Enter Valid OTP received on " + enter_mobile);
      fun_input_focus("enter_otp");
    } else if (is_check == false) {
      alert(checkbox_text);
    } else {
      showLoading();
      // Create an object of formData
      const formData = new Object();
      // Update the formData object
      formData.enter_name = sent_clean_var(enter_name.trim());
      formData.enter_mobile = enter_mobile;
      formData.enter_otp = enter_otp;
      formData.deviceid = getuniquedeviceid();
      // Send formData object
      axios
        .post(CallURL.verify_otp, formData)
        .then((response) => {
          stopLoading();
          //console.log(response);
          //alert(response.data.apires);
          if (response.data.apires == "logindone") {
            //login done
            //save local storage user sec key
            set_login_detail(response.data.fullname, response.data.userseckey);
            //redirect
            if (response.data.is_complete == "1") {
              //go to home
              gotohome();
            } else {
              //go to profile complete
              //gotoeditprofile();
              //go to home
              gotohome();
            }
          } else if (response.data.apires == "wrongotp") {
            alert(
              "you entered wrong OTP.\nenter valid OTP received on " +
                enter_mobile
            );
          } else if (response.data.apires == "deviceissue") {
            alert(
              "your account already login from another device.\nYou can use Contact Us on WhatsApp option at bottom of page."
            );
          } else if (response.data.apires == "validityissue") {
            alert(
              "your account are waiting for admin access.\nYou can use Contact Us on WhatsApp option at bottom of page."
            );
          } else if (response.data.apires == "disableaccount") {
            alert(
              "your account has been disabled.\nYou can use Contact Us on WhatsApp option at bottom of page."
            );
          } else {
            alert("Something went wrong. Try again.");
          }
        })
        .catch((error) => {
          stopLoading();
          console.log(error);
          alert("Something went wrong. Try again.");
        });
    }
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="row ">
          <div className="col s12 m2 l3"></div>
          <div className="col s12 m8 l6 app_view_contain_remove">
            <center>
              <img src={logo} alt="RDA CMS" className="login_logo" />
              <br />
              <hr className="hr_white_remove" />
              <br />
              <font className="font_title font_black">Login</font>
              <br />
              <br />
              <br />
              <div className="user_form_2 user_form_2_fullname">
                <input
                  type="text"
                  id="enter_name"
                  name="enter_name"
                  placeholder="Full Name"
                  className="user_form_2_input"
                  value={enter_name}
                  onChange={(e) => {
                    set_enter_name((enter_name) => e.target.value);
                  }}
                  autoComplete="off"
                  disabled={is_sent}
                />
              </div>
              <br />
              <div className="user_form_2 user_form_2_fullname">
                <input
                  type="text"
                  id="enter_mobile"
                  name="enter_mobile"
                  placeholder="Mobile No"
                  className="user_form_2_input"
                  value={enter_mobile}
                  onChange={(e) => {
                    handle_enter_mobile(e);
                  }}
                  autoComplete="off"
                  disabled={is_sent}
                />
                {(() => {
                  if (is_sent) {
                    return (
                      <i
                        className="fa fa-pencil-square fa-3x"
                        style={{ cursor: "pointer" }}
                        onClick={fun_edit_mobile_no}
                      ></i>
                    );
                  }
                })()}
              </div>
              <br />
              <font className="font_check_box">
                I understand that copying and circulating any of these materials
                is a breach of copyright law If I am found guilty in any such
                activities I shall be legally held liable for the same
              </font>
              <br />
              <Checkbox
                checked={is_check}
                //filledIn
                id="check_accept_terms"
                onChange={(e) => {
                  set_is_check(e.target.checked);
                }}
              />
              <br />
              <br />
              {(() => {
                if (!is_sent) {
                  return (
                    <font
                      className="font_sub_title div_but div_red"
                      onClick={fun_send_otp}
                    >
                      Send OTP
                    </font>
                  );
                } else if (is_sent && timer_count != 0) {
                  return (
                    <font className="font_sub_small_title font_black_count">
                      Resend OTP in {timer_count} Seconds
                    </font>
                  );
                } else if (is_sent) {
                  return (
                    <font
                      className="font_sub_title div_but div_red"
                      onClick={fun_re_send_otp}
                    >
                      Resend OTP
                    </font>
                  );
                }
              })()}
              <br />
              <br />
              {(() => {
                if (is_sent) {
                  return (
                    <>
                      <div className="user_form_2 user_form_2_otp">
                        <input
                          type="text"
                          id="enter_otp"
                          name="enter_otp"
                          placeholder="otp"
                          className="user_form_2_input"
                          value={enter_otp}
                          onChange={(e) => {
                            handle_enter_otp(e);
                          }}
                          autoComplete="off"
                        />
                      </div>
                      <br />
                      <br />
                      <font
                        className="font_title div_but div_red"
                        onClick={fun_verify_otp}
                      >
                        Continue
                      </font>
                    </>
                  );
                }
              })()}
              <br />
              <ContactUs />
            </center>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;
